import DotNetObject = DotNet.DotNetObject;
import { Contract } from '@crimsontide/core/client/interfaces'

export const ContractService = (() => {
  let dotNetObj: DotNetObject;
  let cachedContracts: Contract[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getAll = async (useCache: boolean = true): Promise<Contract[]> => {
    if (useCache && cachedContracts != null)
      return cachedContracts;

    if (dotNetObj) {
      cachedContracts = await dotNetObj.invokeMethodAsync<Contract[]>('GetAllAsync');
      return cachedContracts;
    } else {
      throw 'Contract DotNet Object Reference has not yet been implemented';
    }
  };

  const getByCustomerIds = async (customerIds: string[]): Promise<Contract[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<Contract[]>('GetByCustomerIdsAsync', customerIds);
    } else {
      throw 'Contract DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getAll,
    getByCustomerIds,
  };
})();
